import { ThemeButtonImage } from '@shared/ui/buttons';
import { useCreateCardDialog } from '@utils/dialogs-hooks';
import { useTranslation } from 'react-i18next';

export default function CreateCardBtn() {
  const { openCreateCardDialog } = useCreateCardDialog();
  const { t } = useTranslation();
  return (
    <ThemeButtonImage
      name="create-card"
      animation="rotate-y"
      onClick={() => openCreateCardDialog()}
    >
      {t('create_card')}
    </ThemeButtonImage>
  );
}
